import type { ChatMessage } from './llm';

// ----------------------------------------------------------------------

const TRANSCRIPT_MESSAGES = 6;
const TRANSCRIPT_SNIPPET_CHARS = 400;

const messageText = (message: ChatMessage): string => {
  const { content } = message;
  if (typeof content === 'string') return content;
  if (Array.isArray(content)) {
    return content
      .map((part) => (part && typeof part === 'object' && 'text' in part ? String(part.text) : ''))
      .join(' ');
  }
  return '';
};

export const buildTranscript = (history: ChatMessage[]): string =>
  history
    .filter((message) => message.role === 'user' || message.role === 'assistant')
    .map((message) => ({ role: message.role, text: messageText(message).trim() }))
    .filter(({ text }) => text)
    .slice(-TRANSCRIPT_MESSAGES)
    .map(
      ({ role, text }) =>
        `${role === 'user' ? 'User' : 'Assistant'}: ${
          text.length > TRANSCRIPT_SNIPPET_CHARS
            ? `${text.slice(0, TRANSCRIPT_SNIPPET_CHARS)}…`
            : text
        }`
    )
    .join('\n');

/** Wraps the latest user message with the conversation that gives it meaning. */
export const buildClassifierInput = (userText: string, history: ChatMessage[]): string => {
  const transcript = buildTranscript(history);
  const latest = `LATEST MESSAGE (classify this one):\n${userText}`;
  return transcript ? `Recent conversation:\n${transcript}\n\n${latest}` : latest;
};
